import React from 'react'
import { LuClock } from 'react-icons/lu'
import styles from './scheduleSummary.module.css'
import { formatDuration, formatPrice } from '../../../utils/pricing'

function ScheduleSummaryService({
    service,
}) {
    const attributes = Array.isArray(service?.selected_attributes)
        ? service.selected_attributes
        : (Array.isArray(service?.attributes) ? service.attributes : []);

    return (
        <div className={styles.serviceSummary}>
            <div className={styles.serviceHeader}>
                <h3 className={styles.serviceName}>{service.product.name}</h3>
                <span className={styles.servicePrice}>{formatPrice(service.total_price)}</span>
            </div>

            {attributes.length > 0 && (
                <ul className={styles.attributeList}>
                    {attributes.map((attribute, index) => (
                        <li key={`${attribute.attribute_name ?? 'attribute'}-${index}`} className={styles.serviceAttribute}>
                            <span className={styles.attributeName}>{attribute.attribute_name}</span>
                            <span className={styles.attributeValue}>{attribute.attribute_value}</span>
                        </li>
                    ))}
                </ul>
            )}

            <div className={styles.serviceFooter}>
                <span className={styles.serviceDuration}>
                    <LuClock aria-hidden="true" />
                    {formatDuration(service.total_duration)}
                </span>
            </div>
        </div>
    )
}

export default ScheduleSummaryService
